/**
 * Hospital Redirect Service
 *
 * Provides hospital-specific redirect URLs after call/transaction completion.
 * Maps hospital codes to their respective website URLs.
 */

interface HospitalRedirect {
  [key: string]: string | { th: string; en: string };
}

export const hospitalRedirectService = {
  /**
   * Get redirect URL for a specific hospital code
   * @param partnerName - Partner/hospital code (e.g., "STH", "SSH", "SCH")
   * @param language - Language code ("th" or "en")
   * @returns Redirect URL or null if no specific redirect configured
   */
  getRedirectUrl: (partnerName: string, language: string): string | null => {
    if (!partnerName) return null;

    const code = partnerName.trim().toUpperCase();

    const redirectMap: HospitalRedirect = {
      'STH': 'https://samitivejthonburi.com/',
      'SSH': 'https://www.samitivejsriracha.com/',
      'SCH': {
        'th': 'https://www.samitivejchonburi.com/th/',
        'en': 'https://www.samitivejchonburi.com/en/'
      },
      'SCT': 'https://www.samitivejchinatown.com/'
      // SNH and SVNH/SVH will use default Virtual Hospital page
    };

    const redirect = redirectMap[code];
    if (!redirect) return null;

    // Handle language-specific redirects
    if (typeof redirect === 'string') {
      return redirect;
    }

    // Return language-specific URL, default to Thai if language not found
    return redirect[language as keyof typeof redirect] || redirect['th'];
  }
};
